export enum PathStrategy {
  RouterConnected = 'routerConnected',
  Stateful = 'stateful',
}
